/**
 * Google Analytics integration for Model Gallery
 */

export const initializeAnalytics = () => {
  // Initialize Google Analytics for both development and production
  if (window.gtag && typeof window.gtag === 'function') {
    // Send initial page view
    window.gtag('config', 'G-XWDYKNMWY5');
  }
};

/**
 * Track a page view in Google Analytics
 * @param {string} path - The page path
 * @param {string} title - The page title
 */
export const trackPageView = (path, title) => {
  if (window.gtag && typeof window.gtag === 'function') {
    window.gtag('config', 'G-XWDYKNMWY5', {
      page_path: path,
      page_title: title
    });
  }
};

/**
 * Track an event in Google Analytics
 * @param {string} category - The event category
 * @param {string} action - The event action
 * @param {string} label - The event label (optional)
 * @param {number} value - The event value (optional)
 */
export const trackEvent = (category, action, label = null, value = null) => {
  if (window.gtag && typeof window.gtag === 'function') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }
};